module.exports = __webpack_public_path__ + "static/hero-welcome-2b6098ea6ff3a225038924ed968e346e.svg";